import type { MantineColor } from "@mantine/core";

/**
 * Warn the user when the number of significant digits is greater than this value.
 * IEEE 754 can handle ~15-17 significant digits (it's a range, not a hard limit)
 */
export const MAX_SIGNIFICANT_DIGITS = 17;
export const experimentIconName = "compass";
export const datasetIconName = "table";
export const labelIconName = "tag";
export const deepResearchIconName = "face-disguise";
export const datasetColor: MantineColor = "green";
export const experimentColor: MantineColor = "blue";
export const deepResearchColor: MantineColor = "grape";
export const labelColor: MantineColor = "gray";
export const privateWorkspaceName = "Private";
export const teamIconName = "users";
export const PLUMA_INSIGHTS_TYPEWRITER_DURATION_MS = 5000;
export const localeDefault = navigator.language || "en-US";
